import React from 'react';
import { Link } from "react-router-dom";

export default function WebsiteFooter() {
    return (
        <div id='homepage-footer' className='dark-blue padding-mobilize'>
            <div id='homepage-footer-inner'>
                <div id='homepage-footer-links-container' className='grid-mobilize'>
                    <div className='homepage-footer-column'>
                        <div className='homepage-footer-link-header'>COMPANY</div>
                        <Link className='homepage-footer-link' to='/team'>Our Team</Link>
                    </div>
                    <div className='homepage-footer-column'>
                        <div className='homepage-footer-link-header'>SOLUTIONS</div>
                        <Link className='homepage-footer-link' to='/solutions/highschools'>High Schools</Link>
                        <Link className='homepage-footer-link' to='/solutions/middleschools'>Middle Schools</Link>
                        <Link className='homepage-footer-link' to='/solutions/elementaryschools'>Elementary Schools</Link>
                    </div>
                    <div className='homepage-footer-column'>
                        <div className='homepage-footer-link-header'>RESOURCES</div>
                        <Link className='homepage-footer-link' to='/library'>Schedule Library</Link>
                    </div>
                    <div className='homepage-footer-column'>
                        <div className='homepage-footer-link-header'>CUSTOMERS</div>
                        <Link className='homepage-footer-link' to='/login'>Log In</Link>
                    </div>
                    <div className='homepage-footer-column'>
                        <Link className='homepage-footer-btn' to='/contact'>Book a Demo</Link>
                        <div className='homepage-footer-email'>contact@edario.com</div>
                    </div>
                </div>
                <Link id="homepage-footer-logo-container" to='/'>
                    <img id='homepage-footer-logo-img' src={require("../../../../images/logo-white.png")} alt='Edario Logo' />
                    <div className='homepage-footer-logo-text white-text'>edario</div>
                </Link>
                <div id='homepage-footer-bottom-container'>  
                    <div>© 2026 EDARIO | Edario Master Scheduling</div>
                    <div>ALL RIGHTS RESERVED</div>
                    <Link className='homepage-footer-bottom-link' to='/privacy'>Privacy Policy</Link>
                    <Link className='homepage-footer-bottom-link' to='/terms'>Terms & Conditions</Link>
                </div>
            </div>
        </div>
    );
}
